import type themesEn from "./themes.en";

const themesAr: Record<keyof typeof themesEn, string> = {
  "themes.title": "القوالب",
  "themes.upload": "رفع ملف zip",
  "themes.add": "إضافة قالب",
  "themes.add_title": "مكتبة القوالب",
  "themes.add_short": "إضافة",
  "themes.added": "تمت إضافة {name} إلى مكتبة القوالب",
  "themes.uploaded": "تم رفع {name}",
  "themes.check_failed": "في القالب أخطاء ولم يُحفظ:",
  "themes.current": "القالب الحالي",
  "themes.update_available": "يتوفر تحديث: {version}",
  "themes.version": "الإصدار {version}",
  "themes.saved": "آخر حفظ {when}",
  "themes.customize": "تخصيص",
  "themes.preview": "معاينة",
  "themes.rename": "إعادة التسمية",
  "themes.duplicate": "تكرار",
  "themes.duplicated": "تم تكرار القالب",
  "themes.download": "تنزيل ملف القالب",
  "themes.edit_code": "تعديل الكود",
  "themes.delete": "حذف القالب",
  "themes.delete_title": "حذف {name}؟",
  "themes.delete_body": "سيُحذف هذا القالب وتخصيصاته. لا يمكن التراجع عن ذلك.",
  "themes.deleted": "تم حذف القالب",
  "themes.none_live": "لا يوجد قالب منشور بعد. أضف قالباً من المكتبة.",
  "themes.library": "مكتبة القوالب",
  "themes.library_hint": "قوالب يمكنك تخصيصها ونشرها عندما تكون جاهزاً. قالب واحد فقط يكون منشوراً في كل مرة.",
  "themes.library_empty": "أضف قالباً أو كرّر قالبك الحالي لتجربة التغييرات دون التأثير على متجرك.",
  "themes.publish": "نشر",
  "themes.publish_title": "نشر {name}؟",
  "themes.publish_body": "سيحلّ محل قالبك الحالي في واجهة متجرك فوراً.",
  "themes.published": "{name} منشور الآن",
  "themes.renamed": "تمت إعادة تسمية القالب",
  "themes.name": "اسم القالب",
  "themes.source.library": "من مكتبة القوالب",
  "themes.source.upload": "مرفوع",
  "themes.source.duplicate": "نسخة",
  "themes.view_code": "عرض الشيفرة",
  "themes.dev_title": "تبني قالبك الخاص؟",
  "themes.dev_body": "تستخدم القوالب قوالب Liquid وقوالب JSON وأقسام وكتل. نزّل «ساحل» كنقطة بداية وارفع ملف zip الخاص بك.",
  "themes.errors_title": "أخطاء القالب ({n})",
  "themes.errors_clear": "مسح",
  "themes.errors_hint": "واجه متجرك المنشور أخطاء Liquid هذه خلال آخر 7 أيام. يرى المتسوقون باقي الصفحة؛ ويُحذف الجزء المعطّل.",
};

export default themesAr;
